import PlaceOrderFormTest from "./PlaceOrderFormTest";

const Index = () => {
  return <PlaceOrderFormTest />;
};

export default Index;
